import { VStack, Text, Image, Button, Icon } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import mealBoxImg from '~/assets/images/mealBox.png';

import { IoRestaurantOutline } from 'react-icons/io5';

export default function EmptyContainerPlaceholder() {
  const navigate = useNavigate();

  return (
    <VStack m="auto" spacing={4} w="fit-content">
      <Image src={mealBoxImg} />
      <Text fontSize="sm" color="secondary">
        目前沒有需要歸還的餐盒
      </Text>
      <Button
        isFullWidth
        leftIcon={<Icon as={IoRestaurantOutline} />}
        onClick={() => navigate('/')}
      >
        點餐去
      </Button>
    </VStack>
  );
}
